import React from "react"
import PropTypes from "prop-types"
import WidgetFrameLayout from './WidgetFrameLayout'

const buttonIdFromUrl = (iframeUrl) => {
  if (!iframeUrl) return null

  try {
    return new URL(iframeUrl).searchParams.get('buttonid')
  } catch (_error) {
    return null
  }
}

const buildCredentialWidgetUrl = ({
  buttonId,
  identifier
}) => {
  const params = new URLSearchParams({
    buttonid: buttonId,
    trackid: identifier
  })

  return `/diro/capture-widget?${params.toString()}`
}

const CredentialWidget = ({
  iframeUrl,
  onClose,
  externalIdentifier,
  identifier,
  buttonId,
  widgetScriptUrl,
  widgetStylesheetUrl
}) => {
  const resolvedButtonId = buttonId || buttonIdFromUrl(iframeUrl)
  const widgetUrl = resolvedButtonId && identifier ? buildCredentialWidgetUrl({
    buttonId: resolvedButtonId,
    identifier
  }) : null

  return(
    <WidgetFrameLayout
      externalIdentifier={externalIdentifier}
      onClose={onClose}
      widgetId="credentialWidget"
    >
      {widgetUrl ? (
        <iframe
          id="bankingWidget"
          title="DIRO credential widget"
          src={widgetUrl}
          className="diro-widget-frame"
        />
      ) : (
        <div className="notification is-danger">Missing DIRO credential button configuration.</div>
      )}
    </WidgetFrameLayout>
  )
}

CredentialWidget.propTypes = {
  iframeUrl: PropTypes.string,
  onClose: PropTypes.func,
  externalIdentifier: PropTypes.string,
  identifier: PropTypes.string,
  buttonId: PropTypes.string,
  widgetScriptUrl: PropTypes.string,
  widgetStylesheetUrl: PropTypes.string
}

export default CredentialWidget
